<template>
    <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        :retain-focus="false"
        persistent
        transition="dialog-bottom-transition">
        <template v-slot:activator="{ on, attrs }">
            <v-btn 
                v-bind="attrs"
                v-on="on" 
                x-medium
                large block 
                rounded 
                color="primary"
                dark>
                {{ $t('board.label.addCategory.title') }}
            </v-btn>
        </template>
        <v-card>
            <v-toolbar
              dark
              color="secondary">
                <v-btn
                    icon
                    dark
                    class="btn btn-primary"
                    @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>{{ $t('board.label.addCategory.title') }}</v-toolbar-title>

                <template v-slot:extension>
                  <v-tabs v-model="tab" align-with-title>
                    <v-tabs-slider color="accent"></v-tabs-slider>

                    <v-tab v-for="item in items" :key="item">
                      {{ item }}
                    </v-tab>
                  </v-tabs>
                </template> 

            </v-toolbar>

            <v-tabs-items v-model="tab" class="container mt-5">
              
              <v-tab-item>
                <div class="container mt-4">
                  <addCategories/>
                </div>
              </v-tab-item>
          </v-tabs-items>
  
        </v-card>
    </v-dialog>
  
</template>
  
<script>

  import addCategories from '@/views/categories_board/pages/add_categories/components/form_categories_component.vue';
  import  EventBus  from '@/utils/event_bus.js'; 

  export default { 
    name:"addCategoriesPage",
    components: {
      addCategories,
    },
    data () {
      return {
        dialog: false,
        tab: null,
        items: [
          this.$t('label.tab')
        ],
      }
    }, 
    watch: {
      dialog(newVal) {
        // Cuando el diálogo se cierra, emitir evento para limpiar el formulario
        if (!newVal) {
          EventBus.$emit('clear-categories-form');
        }
      }
    }, 
    mounted() {
      // Escucha el evento emitido por el componente hijo
      EventBus.$on('form-submitted-successfully', () => {
        // Cierra el v-dialog
        this.dialog = false;
        EventBus.$emit('reload-list-categories');
      });
    },
  };
</script>

  